import { useState } from 'react'
import dataSelectField from '@templates/AddNewItemModal/templates/dataSelectField'
import { useGetDangerHazardsQuery } from '@services/dangerHazards'
import { UseDangerField } from '@app-types/riskMapFields'

const useDangerHazardsField: UseDangerField = ({
  params,
  onOneItem,
  skip,
  initFilters,
}) => {
  const [filters, setFilters] = useState(initFilters)

  return {
    setFilters,
    field: (fieldParams) =>
      dataSelectField({
        query: useGetDangerHazardsQuery,
        filters,
        setFilters,
        dropdownWidth: 500,
        label: 'Опасность',
        name: 'hazard',
        withManualEntryText: true,
        withShowLabelInDescription: true,
        onOneItem,
        skip,
        ...params,
        ...fieldParams,
      }),
  }
}

export default useDangerHazardsField
